import { render, staticRenderFns } from "./event-parallel.vue?vue&type=template&id=d21041cc&scoped=true"
import script from "./event-parallel.ts?vue&type=script&lang=ts&external"
export * from "./event-parallel.ts?vue&type=script&lang=ts&external"
import style0 from "./event-parallel.less?vue&type=style&index=0&id=d21041cc&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21041cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d21041cc')) {
      api.createRecord('d21041cc', component.options)
    } else {
      api.reload('d21041cc', component.options)
    }
    module.hot.accept("./event-parallel.vue?vue&type=template&id=d21041cc&scoped=true", function () {
      api.rerender('d21041cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/event-parallel/event-parallel.vue"
export default component.exports